import {JSEncrypt} from "jsencrypt";

// 加密
export function rasEncryption(content) {
  let encryptor = new JSEncrypt() // 创建加密对象实例
  //之前ssl生成的公钥，复制的时候要小心不要有空格
  let pubKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDZYpwYUaZbm+DqGomFQ6Ze7eTW
05XUC0/scfuj+Zav1htAOs6YPyzKm0moqgU5Nd/EzPkJloGQCVRgIRwDr8uHMhMX
a7Z6pDfnQt04IXMz/SdTKBElMRb0xkNVWRUHnZxpIGD32hfI8/qlds6gA49AcWWe
Vde2sUmkSpJYpOGziQIDAQAB`
  encryptor.setPublicKey(pubKey) //设置公钥
  return encryptor.encrypt(content) // 对内容进行加密
}

// 解密
export function rasDecrypt(content) {
  let decrypt = new JSEncrypt() //创建解密对象实例
  //之前ssl生成的秘钥
  let priKey = `MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBANlinBhRplub4Ooa
iYVDpl7t5NbTldQLT+xx+6P5lq/WG0A6zpg/LMqbSaiqBTk138TM+QmWgZAJVGAh
HAOvy4cyExdrtnqkN+dC3TghczP9J1MoESUxFvTGQ1VZFQednGkgYPfaF8jz+qV2
zqADj0BxZZ5V17axSaRKklik4bOJAgMBAAECgYBZCNRZ+YcjWjLCb2AH3u9TTig9
/KcPFBsGAqFIRb98ATtkETHwlV9pFDUVCZ3eEry1xCXz0Vr7fXa7cJQixmubD/uS
EGi284gxx+jggOe+TnxO9w6GVoxOdXV6WMPnqHxGAZjBR7z13G6NnNdFlAR45FSP
C8vrlyUCWKOn7YVZIQJBAP/pFnVSXa6t+CZcHNkS06NPtNESWQSbFKXj5vfsJq9m
PCl5uuEgMOFXoV2abqz5HG9JMFNK4M4ZuJRG3YquqqUCQQDZdhKgL4Ly1p7TTxHr
TyjXew4HDv9l2qXCrdRed799MgM/5PqgXQlX7kitZ6vI5mXYl0an3D+z/a7i965J
jKQVAkB6XpDYpPwbDSE95on82t3Ml86UsrtSUn27HZFSN9//u1lFU+oiwGvfNTH6
OmB14eDQ7iRnj8STiQUUEhbZu8/pAkApkCWzNCGFJHwqyxwTq4eU19Iwiy9JWmcA
NJU4kQ6qcRqp5av5Zo7YnZSKgBwXQ+IHabJ5duE+F6iLfOd060qZAkEA7MfHCx6U
iXD1q/6fp9g5RCt/s7SBthJYoYYjWDelSXTXTW0Et8DLQuDeQ0naU3kr6Dlm/9aP
IfAUFD0tpp5cyw==`
  decrypt.setPrivateKey(priKey) //设置秘钥
  return decrypt.decrypt(content) //解密之前拿公钥加密的内容
}